import { render, staticRenderFns } from "./index-web.vue?vue&type=template&id=5d9f2bb5&scoped=true"
import script from "./index-web.vue?vue&type=script&lang=ts"
export * from "./index-web.vue?vue&type=script&lang=ts"
import style0 from "./index-web.vue?vue&type=style&index=0&id=5d9f2bb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9f2bb5",
  null
  
)

export default component.exports